/**
 * The two- or three-letter marks the design sets in a small mono tile for each
 * kind of source. Kinds without a plugin yet (WhatsApp, Drive, a custom API)
 * are here too, because the catalog shows them as "coming soon".
 */
const SOURCES: Readonly<Record<string, { readonly glyph: string; readonly name: string }>> = {
  quickmanage: { glyph: 'QM', name: 'QuickManage TMS' },
  email: { glyph: 'EM', name: 'Email (IMAP / Gmail)' },
  telegram: { glyph: 'TG', name: 'Telegram account' },
  samsara: { glyph: 'SA', name: 'Samsara' },
  motive: { glyph: 'GM', name: 'GoMotive' },
  whatsapp: { glyph: 'WA', name: 'WhatsApp' },
  gdrive: { glyph: 'GD', name: 'Google Drive' },
  webhook: { glyph: 'API', name: 'Custom API / webhook' },
};

/** Where a row came from when no source is involved: the channel a person used. */
const CHANNELS: Readonly<Record<string, string>> = { telegram: 'TG', web: 'WEB' };

export function sourceGlyph(kind: string): string {
  return SOURCES[kind]?.glyph ?? kind.slice(0, 2).toUpperCase();
}

export function sourceKindName(kind: string): string {
  return SOURCES[kind]?.name ?? kind.charAt(0).toUpperCase() + kind.slice(1);
}

/** An activity row's mark: its source if it has one, else its channel, else a dash. */
export function activityGlyph(row: {
  sourceKind?: string | undefined;
  channel?: string | undefined;
}): string {
  if (row.sourceKind !== undefined) return sourceGlyph(row.sourceKind);
  if (row.channel !== undefined) return CHANNELS[row.channel] ?? row.channel.toUpperCase();
  return '—';
}
